import React,{Component} from "react"
import moment from 'moment';
import momentz from 'moment-timezone';
import store from "./store/index";
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import date from "../node_modules/date-and-time"
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import Row from 'react-bootstrap/Form'
import './index.css';
import { updateTimeSettingsOneByOne } from "./actions/index";
import { updateT0Settings } from "./actions/index";

const showSecond = false;
const str = showSecond ? 'HH:mm:ss' : 'HH:mm';

function minutesToHHMM(mins) {
  if(mins<0){
    return '00:00'
  }
let h = Math.floor(mins / 60);
let m = mins % 60;
  m = m < 10 ? '0' + m : m;
  h = h < 10 ? '0' + h : h;
  return `${h}:${m}`;
}
const spacer={
  height:'5px'
}

const marginRight={
  marginRight:'5px'
}

const inlineBlock = {
  display:'inline-block',
  width:'50%',
  color:'white',
}



const timerSize={
  width:'100px'
}
const timerSize1={
  width:'100px',
  fontSize:'12px',
  color:'#666',
  paddingLeft:'5px'
}

function getTimeDiffInMins(timeDiff){
  var hours =parseInt(timeDiff.substring(0,2))
  var mints =parseInt(timeDiff.substring(3,5))

  return (hours*60+mints)

}



class TimeSetterT0 extends Component{


  constructor(props) {
    super(props);
    this.state = {
      timerSelected: "exact",
      timeinDiff: store.getState().t0Settings.diff
    }

    //const unsubscribe = store.subscribe(handleChange)
    //unsubscribe()
    this.updateState23 = this.updateState23.bind(this)
    this.handleTimeChangeEventDefault = this.handleTimeChangeEventDefault.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleTimeChangeEvent = this.handleTimeChangeEvent.bind(this)
    this.handleTimeChangeEventInDiff = this.handleTimeChangeEventInDiff.bind(this)
    //store.subscribe(this.updateState23)
  }

  updateState23(){
    let difftime = store.getState().t0Settings.diff
    let isExact = store.getState().t0Settings.option

    //console.log( " Option : "+isExact+" Diff: "+difftime);
    this.setState(
      {
        timerSelected: isExact,
        timeinDiff: difftime
      }
    )
  }

  getTimeDiffInMins(timeDiff){
    var hours =parseInt(timeDiff.substring(0,2))
    var mints =parseInt(timeDiff.substring(3,5))

    return (hours*60+mints)

  }

  handleChange(event) {
    //console.log("SDSDSD"+event.target.value);
    let payload={}
    payload.id = "option"
    payload.value = event.target.value
    store.dispatch( updateT0Settings(payload))

  this.setState({
    timerSelected: event.target.value
  });
}

handleTimeChangeEventDefault(){
    let timeDiff = moment().tz("Etc/GMT")
    let val = minutesToHHMM(timeDiff)
    let payload={}
    payload.option = "exact"
    payload.value = timeDiff
    store.dispatch(updateT0Settings(payload))
}

  handleTimeChangeEvent(value){
    
    //console.log("Received val :: "+value);
      let timeDiff = moment(value).tz("Etc/GMT")
      let payload={}
      payload.option = "exact"
      payload.value = timeDiff
      //store.dispatch( updateT0Settings(payload))

  }
  handleTimeChangeEventInDiff(event){
      //let timeDiff = moment().tz("Etc/GMT").diff(value,'minutes')
      //console.log("Time in Diff  to settings :: "+event.target.value);
      let val = minutesToHHMM(event.target.value)
      let payload={}
      payload.id = "diff"
      payload.value = event.target.value
      store.dispatch( updateT0Settings(payload))

      this.setState({
        timeinDiff: event.target.value
      });

  }
  render(){


    var isExactTime = store.getState().t0Settings.option == "exact" ? true : false;


this.handleTimeChangeEventDefault();
//console.log("TO SETTINGS ::"+store.getState().t0Settings.diff);
//console.log("Time DIFF in TO:: "+this.state.timeinDiff + " is Exact Time : "+this.state.timerSelected);

    return(
      <div as={Row} class="divMargin1">
      <div as={Row}  class="textColor1">
      {this.props.label} Options
      </div>
      <form>
        <div style={inlineBlock}>
        <input
        type="radio"
        name="fruit"
        value="exact"
        checked={isExactTime}
        onChange={this.handleChange}
        style={marginRight}/>Exact time</div>
        <div style={inlineBlock}>
        <div style={timerSize}>
        <TimePicker as={Row}
        format={str}
        disabled={!isExactTime}
        popupStyle={{ width: 200, fontSize: 20}}
        showSecond={showSecond}
        value={moment().tz("Etc/GMT").add(store.getState().localTimeOffSetToGmt,'minutes')}
        defaultValue={moment(store.getState().t0Settings.exact).add(store.getState().localTimeOffSetToGmt,'minutes')}
        className="textpicker"
        id={this.state.element}
        onChange={this.handleTimeChangeEvent}
        />
        </div>
        </div>
        <div style={spacer}></div>
        <div style={inlineBlock}>
        <input
        type="radio"
        name="fruit"
        value="diff"
        checked={!isExactTime}
        onChange={this.handleChange}
        style={marginRight} />Minutes before now</div>
        <div style={inlineBlock}>
        <input
        id="timeSetT1"
        type="number"
        style={timerSize1}
        disabled={isExactTime}
        onChange={this.handleTimeChangeEventInDiff}
        value={store.getState().t0Settings.diff}
        defaultValue={store.getState().t0Settings.diff}/></div>
      </form>

      </div>
    )
  }
}
export default TimeSetterT0
